// extracted by mini-css-extract-plugin
export default {"modal":"Z1-z","modalOverlay":"_1-z","outfitHeading":"a2-z"};